import { cn } from '@/lib/utils'

/** The id of the app shell's content surface, the skip link's target. */
export const MAIN_CONTENT_ID = 'main-content'

/**
 * "Skip to content": the first stop on Tab, hidden until focused. Keyboard
 * and screen-reader users otherwise tab through the whole sidebar and header
 * on every page before reaching it. Focuses the surface directly instead of
 * following "#main-content", which would change the route's hash.
 */
export function SkipToContent({ className }: { className?: string }) {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      onClick={event => {
        const target = document.getElementById(MAIN_CONTENT_ID)
        if (!target) return
        event.preventDefault()
        target.focus()
      }}
      className={cn(
        'focus:rounded-control sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:bg-background focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-foreground focus:shadow-md',
        className,
      )}
    >
      Skip to content
    </a>
  )
}
